import test from './sample';
import '../css/style.scss';

console.log(test('testeee!!!!'));

const fv = document.querySelector('.fv');
const lpWrapper = document.querySelector('#wrapper');
const fvPcLoading = document.querySelector('.l-pc__loading');
const fvLoading = document.querySelector('.fv__loading');
const fvPcLogo = document.querySelector('.l-pc__logo');
const fvLogo = document.querySelector('.fv__logo');
const fvTtl = document.querySelector('.fv__ttl');
const fvPcTtl = document.querySelector('.l-pc__ttl');
const pcBg = document.querySelector('.pc-blur-filter');
const bg = document.querySelector('.blur-filter');
const body = document.querySelector('body');
const afterLoad = document.querySelectorAll('.after-load');

const loadingFunc = function () {
  document.addEventListener('DOMContentLoaded', () => {
    fvLoading?.classList.remove('hidden');

    body?.classList.add('no-scroll');
    bg?.classList.add('bluring');
    afterLoad.forEach((block) => {
      block.classList.add('unshown');
    });
    fvLogo?.classList.add('hidden');
    fvTtl?.classList.add('hidden');
  });
  const wait = function (seconds: number) {
    return new Promise(function (resolve) {
      setTimeout(resolve, seconds * 1000);
    });
  };

  wait(1.5)
    .then(() => {
      fvLoading?.classList.add('hide-up-fade');
      return wait(0.7);
    })
    .then(() => {
      bg?.classList.remove('bluring');
      return wait(2);
    })
    .then(() => {
      fvLogo?.classList.remove('hidden');
      fvTtl?.classList.remove('hidden');
      return wait(0.6);
    })
    .then(() => {
      body?.classList.remove('no-scroll');
      afterLoad.forEach((block) => {
        block.classList.remove('unshown');
      });
    });
};

const pcLoadingFunc = function () {
  document.addEventListener('DOMContentLoaded', () => {
    fvPcLoading?.classList.remove('hidden');
    lpWrapper?.classList.add('hidden');
    body?.classList.add('no-scroll');
    bg?.classList.add('bluring');
    afterLoad.forEach((block) => {
      block.classList.add('unshown');
    });
    fvPcLogo?.classList.add('hidden');
    fvPcTtl?.classList.add('hidden');
  });
  const wait = function (seconds: number) {
    return new Promise(function (resolve) {
      setTimeout(resolve, seconds * 1000);
    });
  };

  wait(1.5)
    .then(() => {
      fvPcLoading?.classList.add('hide-up-fade');
      return wait(0.7);
    })
    .then(() => {
      pcBg?.classList.remove('bluring');
      return wait(2);
    })
    .then(() => {
      fvPcLogo?.classList.remove('hidden');
      fvPcTtl?.classList.remove('hidden');
      lpWrapper?.classList.remove('hidden');
      return wait(0.6);
    })
    .then(() => {
      body?.classList.remove('no-scroll');
      afterLoad.forEach((block) => {
        block.classList.remove('unshown');
      });
    });
};

// スクロールでBlur
// const scrollBlurFunc = function () {
//   const initialScrollY = window.scrollY;
//   const blurStart = 30;

//   const setBlur = () => {
//     const movedDown = window.scrollY - initialScrollY;

//     if (movedDown > blurStart) {
//       bg?.classList.add('bluring-dark');
//       window.removeEventListener('scroll', setBlur);
//     }
//   };

//   window.addEventListener('scroll', setBlur, { passive: true });
// };

// FVの時はブラー外し
const unsetBlur = function () {
  const deleteBlur: IntersectionObserverCallback = function (
    entries,
    _observer,
  ) {
    const [entry] = entries;
    console.log(entry);
    if (entry.isIntersecting) {
      bg?.classList.remove('bluring-dark');
    } else {
      bg?.classList.add('bluring-dark');
    }
  };

  const fvObserver = new IntersectionObserver(deleteBlur, {
    root: null,
    threshold: 0.5,
  });
  fvObserver.observe(fv!);
};

// 画像のフェードイン
const imageFadeIn = function () {
  const allImages = document.querySelectorAll('.image');

  const showImage: IntersectionObserverCallback = function (
    entries,
    _observer,
  ) {
    const [entry] = entries;
    if (!entry.isIntersecting) return;
    entry.target.classList.remove('image--hidden');
    _observer.unobserve(entry.target);
  };

  const imageObserver = new IntersectionObserver(showImage, {
    root: null,
    threshold: 0.7,
  });

  allImages.forEach(function (image) {
    image.classList.add('image--hidden');
    imageObserver.observe(image);
  });
};

const init = function () {
  if (window.matchMedia('(max-width: 600px)').matches) {
    loadingFunc();
    unsetBlur();
  }
  if (window.matchMedia('(min-width: 1200px)').matches) {
    pcLoadingFunc();
  }
  // scrollBlurFunc();
  imageFadeIn();
};
init();
